import React, {type FC, useEffect} from 'react';
import classNames from 'classnames';
import {withGlobals} from '../../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../../gallery/galleryGlobalStrategy';
import {Button, StatesButtonStates, ButtonProps, Spinner, SpinnerTypes} from 'wix-ui-tpa/cssVars';
import {Check} from '@wix/wix-ui-icons-common';
import s from './IconStatesButton.scss';
import {classes as iconStatesButtonStyle} from './IconStatesButton.st.css';
import {useAddToCartIcon} from '../hooks/useAddToCartIcon';
import {useAddToCartNotificationEnd} from '../hooks/useAddToCartNotificationEnd';
import {useStylesParams} from '../../../../../stylesParamsContext';
import {useStyles} from '@wix/tpa-settings/react';

interface IIconStatesButtonProps extends IGalleryGlobalProps {
  addToCartButtonProps: ButtonProps;
  productId: string;
  state: StatesButtonStates;
}

const IconStatesButtonComp: FC<IIconStatesButtonProps> = ({addToCartButtonProps, productId, state}) => {
  const styles = useStyles();
  const stylesParams = useStylesParams();

  const icon = styles.get(stylesParams.gallery_addToCartButtonIcon);

  const {handleNotificationEnd} = useAddToCartNotificationEnd(productId);
  const {iconsMapper} = useAddToCartIcon();

  const getIconCompForIconOnlyButton = () => {
    if (state === StatesButtonStates.IN_PROGRESS) {
      return (
        <Spinner
          type={SpinnerTypes.slim}
          className={classNames(iconStatesButtonStyle.spinner, s.iconContainer, s.spinner)}
        />
      );
    }

    if (state === StatesButtonStates.SUCCESS) {
      return (
        <i className={classNames(s.iconContainer, s.success)}>
          <Check className={s.icon} />
        </i>
      );
    }

    const Icon = iconsMapper[icon];
    return (
      <i className={s.iconContainer}>
        <Icon className={s.icon} />
      </i>
    );
  };

  useEffect(() => {
    if (state === StatesButtonStates.SUCCESS || state === StatesButtonStates.IN_PROGRESS) {
      const timer = setTimeout(handleNotificationEnd, 3000);
      return () => clearTimeout(timer);
    }
  }, [state, handleNotificationEnd]);

  return <Button {...addToCartButtonProps}>{getIconCompForIconOnlyButton()}</Button>;
};

export const IconStatesButton = withGlobals(IconStatesButtonComp);
